// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"44b655c1","732":"60d277b5","977":"b7f0e32a"}[chunkId] + ".chunk.js";
};